import React, { ReactNode } from 'react';

import classes from './TimerBlock.module.scss';
import { CountdownTimer } from '../../../../../shared/components/ui-components';

type TimerBlockProps = {
  expirationEpoch: number;
  description: ReactNode;
};

const TimerBlock = ({ expirationEpoch, description }: TimerBlockProps) => {
  return (
    <div className={classes.container}>
      <CountdownTimer expirationEpoch={expirationEpoch} />
      <div className={classes.description}>{description}</div>
    </div>
  );
};

export { TimerBlock };
